// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-pagination-bullet {
    width: 16px;
    height: 16px;
    background-color: #D9D9D9;
    opacity: 1;
}

.swiper-pagination-bullet-active {
    background-color: #A6A6A6;
    /* Customize the active bullet color */
}`, "",{"version":3,"sources":["webpack://./src/components/ProductsCollection/ProductsCollection.scss"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;AAC1C","sourcesContent":[".swiper-pagination-bullet {\n    width: 16px;\n    height: 16px;\n    background-color: #D9D9D9;\n    opacity: 1;\n}\n\n.swiper-pagination-bullet-active {\n    background-color: #A6A6A6;\n    /* Customize the active bullet color */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
